import { useAuth } from "./context/AuthContext";
import { Login } from "./components/Login";
import { Register } from "./components/Register";
import { GuestDashboard } from "./components/GuestDashboard";
import { Dashboard } from "./components/Dashboard";
import { PaymentSuccess } from "./components/PaymentSuccess";
import { TenantPortal } from "./components/TenantPortal";
import { FounderBanner } from "./components/FounderBanner";
import { Privacy } from "./components/Privacy";
import { ResetPassword } from "./components/ResetPassword";
import { Footer } from "./components/Footer";
import { Landing } from "./components/Landing";

// Pages that work the same with or without a session
const AUTH_PAGES = ['/login', '/registro'];

const PUBLIC_PAGES = {
  '/tenant-portal': TenantPortal,
  '/disputas': TenantPortal,
  '/privacidad': Privacy,
  '/restablecer': ResetPassword,
};

const Page = ({ authMode, setAuthMode }) => {
  const { user, loading, isGuestMode } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Check for different routes
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  if (path === '/payment/success') {
    return <PaymentSuccess />;
  }

  // Logged-in users who open /login or /registro just get their dashboard
  if (user && AUTH_PAGES.includes(path)) {
    window.history.replaceState(null, '', '/');
  }

  const PublicPage = PUBLIC_PAGES[path];
  if (PublicPage) {
    return <PublicPage />;
  }

  // Guest mode
  if (isGuestMode) {
    return <GuestDashboard setAuthMode={setAuthMode} />;
  }

  if (!user && authMode === 'landing') {
    return <Landing setAuthMode={setAuthMode} />;
  }

  if (!user) {
    return (
      <>
        <FounderBanner
          ctaLabel={authMode === 'login' ? 'Obtener acceso fundador' : undefined}
          onCta={authMode === 'login' ? () => setAuthMode('register') : undefined}
        />
        {authMode === 'login'
          ? <Login onSwitch={setAuthMode} />
          : <Register onSwitch={setAuthMode} />}
      </>
    );
  }

  return <Dashboard />;
};

const AppContent = (props) => (
  <>
    <Page {...props} />
    <Footer />
  </>
);

export { AppContent };
